module.exports = __webpack_public_path__ + "static/media/LATINS_HALL-ENTREE.ee3a64ca.jpg";